import React from 'react';
import { Tags, ChartColumn, Store, User } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';

export default function TagAnalytics({ tags }) {
    const analytics = React.useMemo(() => {
        const totalTags = tags?.length || 0;
        const tagsWithSOS = tags?.filter((t) => t.hasSosTargets)?.length || 0;

        // Count total usages
        const totalUsages = tags?.reduce((sum, t) => sum + (t.usageCount || 0), 0) || 0;

        // Count by applicable model
        const userTags = tags?.filter((t) => t.applicableModels?.includes('User'))?.length || 0;
        const storeTags = tags?.filter((t) => t.applicableModels?.includes('Store'))?.length || 0;
        const clientTags = tags?.filter((t) => t.applicableModels?.includes('Client'))?.length || 0;

        return { totalTags, tagsWithSOS, totalUsages, userTags, storeTags, clientTags };
    }, [tags]);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
            <StatCard label="Total Etiquetas" value={formatNumber(analytics.totalTags)} icon={<Tags />} tone="brand" hint="Etiquetas creadas" />
            <StatCard
                label="Con Objetivos SOS"
                value={formatNumber(analytics.tagsWithSOS)}
                icon={<ChartColumn />}
                tone="violet"
                hint="Share of Shelf configurado"
            />
            <StatCard label="Usos Totales" value={formatNumber(analytics.totalUsages)} icon={<Store />} tone="info" hint="Asignaciones activas" />
            <StatCard label="Para Usuarios" value={formatNumber(analytics.userTags)} icon={<User />} tone="success" hint="Etiquetas de usuario" />
        </div>
    );
}
